import { AnyAction } from 'redux';
import {
  CART_ADD_TO_CART_ANIMATION,
  CART_RECEIVE,
  CART_SHOW_MINI_CART,
} from '../constants';
import { OrderRow } from '../Types/OrderRow';

interface FeeItem {
  name: string;
  cost: string;
  priceExcludingVat: number;
  priceIncludingVat: number;
}

export interface CartState {
  quantity: number;
  orderTotal: number;
  gtmGrandTotal: number;
  showMiniCart: boolean;
  addToCartAnimating: boolean;
  orderRows: OrderRow[];
  emptyCartLink?: string;
  checkoutUrl?: string;
  screenCheckoutUrl?: string;
  discount?: string;
  deliveryCost?: string;
  paymentCost?: string;
  grandTotal?: string;
  vat?: string;
  total: number;
  currency: string;
  fees?: FeeItem[];
  productTotal: string;
}

const DEFAULT_STATE: CartState = {
  quantity: 0,
  orderTotal: 0,
  gtmGrandTotal: 0,
  showMiniCart: false,
  addToCartAnimating: false,
  orderRows: [],
  currency: '',
  total: 0,
  productTotal: '',
};

export const cart = (
  state = DEFAULT_STATE,
  action: AnyAction
): CartState => {
  switch (action.type) {
    case CART_RECEIVE:
    case CART_SHOW_MINI_CART:
    case CART_ADD_TO_CART_ANIMATION:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
